/* ============================================================
   Portal B2B Klintensiv — Landing interactions
   Ported from landing-nelogat.js: hero carousel + FAQ accordion
   + scroll-reveal ONLY. The sticky-header / mega-menu / mobile-nav
   handlers are intentionally dropped (Dawn owns the header/footer).

   Rewritten for Shopify sections:
   - each behaviour binds per root element and self-guards against
     double-init (data-kl-bound), so multiple instances are safe;
   - re-runs on the theme-editor `shopify:section:load` event.
   ============================================================ */
(function(){
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Hero carousel (one per .kl-hero root) ---- */
  function initHero(root){
    if(root.dataset.klBound) return;
    root.dataset.klBound = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.hero-slide'));
    var dotsWrap = root.querySelector('.hero__dots');
    if(!slides.length || !dotsWrap) return;

    var current = 0, timer = null;
    var rawAutoplay = root.getAttribute('data-autoplay');
    var AUTOPLAY = rawAutoplay == null ? 6000 : parseInt(rawAutoplay, 10);

    slides.forEach(function(_, i){
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Slide ' + (i + 1));
      b.addEventListener('click', function(){ go(i); rest(); });
      dotsWrap.appendChild(b);
    });
    var dots = Array.prototype.slice.call(dotsWrap.children);

    function go(i){
      current = (i + slides.length) % slides.length;
      slides.forEach(function(s, idx){ s.classList.toggle('active', idx === current); });
      dots.forEach(function(d, idx){ d.classList.toggle('active', idx === current); });
    }
    function next(){ go(current + 1); }
    function prev(){ go(current - 1); }
    function start(){ if(reduce || slides.length < 2 || AUTOPLAY <= 0) return; stop(); timer = setInterval(next, AUTOPLAY); }
    function stop(){ if(timer){ clearInterval(timer); timer = null; } }
    function rest(){ stop(); start(); }

    var arrNext = root.querySelector('.hero__arrows .next');
    var arrPrev = root.querySelector('.hero__arrows .prev');
    if(arrNext) arrNext.addEventListener('click', function(){ next(); rest(); });
    if(arrPrev) arrPrev.addEventListener('click', function(){ prev(); rest(); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    /* swipe */
    var sx = 0;
    root.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function(e){
      var dx = e.changedTouches[0].clientX - sx;
      if(Math.abs(dx) > 50){ dx < 0 ? next() : prev(); rest(); }
    }, { passive: true });

    go(0); start();
  }

  /* ---- FAQ accordion (one per .kl-faq root) ---- */
  function initFaq(root){
    if(root.dataset.klBound) return;
    root.dataset.klBound = '1';

    root.querySelectorAll('.faq-q').forEach(function(q){
      q.addEventListener('click', function(){
        var item = q.closest('.faq-item');
        var ans = item.querySelector('.faq-a');
        var isOpen = item.classList.contains('open');
        var group = q.closest('.faq');
        group.querySelectorAll('.faq-item.open').forEach(function(o){
          if(o !== item){ o.classList.remove('open'); o.querySelector('.faq-a').style.maxHeight = null; }
        });
        if(isOpen){ item.classList.remove('open'); ans.style.maxHeight = null; }
        else{ item.classList.add('open'); ans.style.maxHeight = ans.scrollHeight + 'px'; }
      });
    });
  }

  /* ---- Scroll reveal (expressive, reduced-motion safe) ---- */
  var io = null;
  function getObserver(){
    if(io) return io;
    io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -7% 0px' });
    return io;
  }
  function initReveal(scope){
    if(reduce || !('IntersectionObserver' in window)) return;
    var revealSel = '.sec-head,.card,.seg-card,.pack-card,.recap-card,.testi,.step,.compare__col,.qr-mock,.tier-wrap,.logo-strip,.trust__item';
    var els = Array.prototype.slice.call(scope.querySelectorAll(revealSel));
    if(!els.length) return;
    document.documentElement.classList.add('kl-motion');
    var obs = getObserver();
    var seen = [];
    els.forEach(function(el){
      if(el.dataset.klReveal) return;
      el.dataset.klReveal = '1';
      el.classList.add('reveal');
      var p = el.parentElement;
      if(seen.indexOf(p) < 0) seen.push(p);
      var idx = (p.__ri = (p.__ri == null ? 0 : p.__ri + 1));
      el.style.setProperty('--rd', (Math.min(idx, 6) * 60) + 'ms');
      obs.observe(el);
    });
  }

  /* ---- Boot ---- */
  function boot(scope){
    scope.querySelectorAll('.kl-hero').forEach(initHero);
    scope.querySelectorAll('.kl-faq').forEach(initFaq);
    initReveal(scope);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ boot(document); });
  } else {
    boot(document);
  }

  /* Theme-editor live reload: re-init only the loaded section. */
  document.addEventListener('shopify:section:load', function(e){
    var scope = e.target || document;
    boot(scope);
  });
})();
